import { render, staticRenderFns } from "./AmostraInfo.vue?vue&type=template&id=348eac02&scoped=true"
import script from "./AmostraInfo.vue?vue&type=script&lang=js"
export * from "./AmostraInfo.vue?vue&type=script&lang=js"
import style0 from "./AmostraInfo.vue?vue&type=style&index=0&id=348eac02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348eac02",
  null
  
)

export default component.exports